import { adoptedSheets } from './styles.js';

export abstract class BaseComponent extends HTMLElement {
  protected shadow: ShadowRoot;
  private componentSheet: CSSStyleSheet | null = null;

  constructor() {
    super();
    this.shadow = this.attachShadow({ mode: 'open' });
    this.shadow.adoptedStyleSheets = [...adoptedSheets];
  }

  connectedCallback(): void {
    this.applyComponentStyles();
    this.render();
    this.afterRender();
  }

  protected abstract template(): string;

  protected styles(): string {
    return '';
  }

  protected afterRender(): void { }

  private applyComponentStyles(): void {
    const componentStyles = this.styles();
    if (componentStyles && !this.componentSheet) {
      this.componentSheet = new CSSStyleSheet();
      this.componentSheet.replaceSync(componentStyles);
      this.shadow.adoptedStyleSheets = [...adoptedSheets, this.componentSheet];
    }
  }

  protected render(): void {
    this.shadow.innerHTML = this.template();
  }

  protected $(selector: string): HTMLElement | null {
    return this.shadow.querySelector(selector);
  }

  protected $all(selector: string): NodeListOf<HTMLElement> {
    return this.shadow.querySelectorAll(selector);
  }

  protected emit<T>(eventName: string, detail?: T): void {
    this.dispatchEvent(
      new CustomEvent(eventName, {
        detail,
        bubbles: true,
        composed: true,
      })
    );
  }
}
